import { ReactNode, useEffect } from 'react';
import clsx from 'clsx';
import { Text } from './text';
import { Icon } from './icon';
import CloseIcon from '@assets/icons/close.svg';

export type IModalProps = React.PropsWithChildren & {
  isOpen: boolean;
  onClose: () => void;
  title: string | ReactNode;
  width?: string;
  position?: 'top' | 'center';
  setAutoCloseSeconds?: number;
};

export const Modal = (props: IModalProps) => {
  const { position = 'center' } = props;

  useEffect(() => {
    if (!props.isOpen || !props.setAutoCloseSeconds) return;

    const timerId = setTimeout(() => {
      props.onClose();
    }, props.setAutoCloseSeconds * 1000);

    return () => {
      clearTimeout(timerId);
    };
  }, [props.isOpen, props.setAutoCloseSeconds, props.onClose]);

  if (!props.isOpen) return null;

  const handleOverlayClick = (e: React.MouseEvent) => {
    if (e.currentTarget === e.target) {
      props.onClose();
    }
  };

  return (
    <div className='flex z-[99] top-0 left-0 fixed w-dvw h-dvh bg-almost-dark-black' onClick={handleOverlayClick}>
      <div
        className={clsx('flex flex-col p-6 min-w-[332px] max-h-[90vh] overflow-y-auto  bg-white dark:bg-eerie-black', {
          ['absolute top-[5dvh] left-1/2 -translate-x-1/2']: position === 'top',
          ['m-auto']: position === 'center',
        })}
        style={{ width: props.width }}
      >
        <div className='flex justify-between mb-4'>
          <Text className='pr-8' size='2xl'>
            {props.title}
          </Text>
          <span className='w-8 h-8 cursor-pointer' onClick={props.onClose}>
            <Icon icon={<CloseIcon />} className='cursor-pointer' onClick={props.onClose} />
          </span>
        </div>
        {props.children}
      </div>
    </div>
  );
};
